import React, { useContext, useEffect, useState } from "react";
import CardDownload from "./CardDownload";
import CardHeaderPage from "../UiComponents/card/CardHeaderPage";
import { BsMusicNoteList, BsBook, BsFillCloudUploadFill } from "react-icons/bs";
import { HiOutlineShieldExclamation } from "react-icons/hi";
import styles from "./DownloadOwner.module.scss";
import NavContext from "../../context/NavContext";
import AxiosDownload from "../../_services/download.service";
import Axios from "../../_services/caller.service";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";
import { toast } from "react-toastify";
import { PermissionGate } from "../superAdmin/managePermissions/PermissionGate";

// 💡 Fonction utilitaire de téléchargement de fichier
const handleFileDownload = (response, defaultFilename = "file.zip") => {
  const contentDisposition = response.headers["content-disposition"];
  let filename = defaultFilename;

  if (contentDisposition) {
    const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (matches?.[1]) filename = matches[1].replace(/['"]/g, "");
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const DownloadOwner = () => {
  const {
    ownerId,
    progressWord,
    setProgressWord,
    setProgressHearing,
    progressHearing,
    setProgressManual,
    progressManual,
    adminProfile,
  } = useContext(NavContext);

  const [mobile, setMobile] = useState(false);
  const [restriction, setRestriction] = useState("");

  useEffect(() => {
    Axios.get(`/getOwnerGroup/${ownerId}`)
      .then((response) => {
        const userRestriction = response.data.userGroup.restriction;
        setRestriction(userRestriction);
      })
      .catch(console.error);
  }, [ownerId]);

  useEffect(() => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      setMobile(true);
    }
  }, []);

  // 🧩 Fonction générique de téléchargement
  const downloadFile = (endpoint, setProgress, defaultFilename) => {
    setProgress(0);
    AxiosDownload.get(endpoint, {
      onDownloadProgress: (e) => {
        const percent = Math.round((e.loaded * 100) / (e.total || 1));
        setProgress(percent);
      },
    })
      .then((response) => {
        handleFileDownload(response, defaultFilename);
        toast.success(`✅ Téléchargement terminé : ${defaultFilename}`);
        setTimeout(() => setProgress(0), 2000); // reset après quelques secondes
      })
      .catch((error) => {
        console.error("Erreur de téléchargement :", error);
        toast.error("❌ Une erreur est survenue pendant le téléchargement.");
        setProgress(0);
      });
  };

  // Téléchargement spécifique
  const downloadHearing = () => {
    if (progressHearing > 0 && progressHearing < 100) return;
    downloadFile(`/dwHearing/${ownerId}`, setProgressHearing, "HearingSpaceSetup.zip");
  };

  const downloadWords = () => {
    if (progressWord > 0 && progressWord < 100) return;
    downloadFile(`/dwWords/${ownerId}`, setProgressWord, "HearingSpaceFrenchWords.zip");
  };

  const downloadManual = () => {
    setProgressManual(100); // Simule une progression immédiate
    window.open("https://hearing-space.com/hs-manual", "_blank");
    setTimeout(() => setProgressManual(0), 2000);
  };

  return (
  <motion.div
    variants={animatePage}
    initial="hidden"
    animate="visible"
    exit="exit"
    className={styles.container}
  >
    <CardHeaderPage text="Mes Téléchargements" />

    <div className={styles.containerCard}>
      {/* Bloc avec permission downloadHearingSpace */}
      <PermissionGate actionKey="download.HearingSpaceAndWords">
        {!mobile && (
          <>
            <CardDownload
              onClick={downloadHearing}
              title={"Hearing Space"}
              svg={<BsFillCloudUploadFill />}
              content={"Hearing space"}
              progressBar={progressHearing}
            />
            <CardDownload
              onClick={downloadWords}
              title={"Liste du CNA"}
              svg={<BsMusicNoteList />}
              content={"Liste des mots du Collège National d'Audioprothèse"}
              progressBar={progressWord}
            />
          </>
        )}
      </PermissionGate>

      {/* Bloc toujours accessible ou avec une autre permission */}
     
        <CardDownload
          onClick={downloadManual}
          title={"Manuel d'utilisation"}
          svg={<BsBook />}
          content={"Manuel d'utilisation"}
          progressBar={progressManual}
        />
  
    </div>

    {(progressHearing !== 0 || progressManual !== 0 || progressWord !== 0) &&
      (progressHearing < 100 ||
        progressManual < 100 ||
        progressWord < 100) && (
        <div className={styles.messageUser}>
          <HiOutlineShieldExclamation
            style={{ fontSize: "35px", color: "orange" }}
          />
          <p>
            Veuillez ne pas quitter cette page ni la rafraîchir pendant le
            téléchargement en cours.
            <br />
            Cela annulera le processus de téléchargement.
            <br />
            Veuillez patienter jusqu'à ce que le téléchargement soit terminé.
          </p>
        </div>
      )}
  </motion.div>
);

};

export default DownloadOwner;
